import { render, staticRenderFns } from "./H2Button.vue?vue&type=template&id=1db92e74&"
import script from "./H2Button.vue?vue&type=script&lang=js&"
export * from "./H2Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports